<template>
  <SocialsViewWrapper>
    <TwitterArticlesParams />
    <LoaderFullPage v-if="store.loading" />
    <TwitterArticlesDatas v-else />
  </SocialsViewWrapper>
</template>

<script setup>
import SocialsViewWrapper from "@follaw-fr/components/social-media/templates/SocialsViewWrapper.vue";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import TwitterArticlesDatas from "@follaw-fr/components/social-media/organisms/TwitterArticlesDatas.vue";
import TwitterArticlesParams from "@follaw-fr/components/social-media/organisms/TwitterArticlesParams.vue";
import { useTwitterArticlesStore } from "@follaw-fr/stores/social-media/articles";
import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";
import { PermissionLevel } from "@/follaw-fr/constants/enums/permission-level.enum";

const store = useTwitterArticlesStore();
const userSettingsStore = useUserSettingsStore();

if (userSettingsStore.hasPermission(PermissionLevel.SOCIETAL)) {
  store.selectedFilters.from = 0;
  store.fetchTwitterArticlesList();
}
</script>
